import Vue from 'vue';
export default Vue.extend({
    name: 'UserTypeSelect',
    props: {
        value: {
            type: String,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        clickHandler(event) {
            if (this.readOnly) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
    }
});
